import React from "react";

// Components
import { IonPage } from "@ionic/react";
import Header from "../Header/Header";

// Styles
import "./BasicTemplate.scss";

class AdminTemplate extends React.Component<any, any> {
  render() {
    const { hideHeader, hideBackButton, backButtonLink, hideHamburger } = this.props;

    return (
      <IonPage className={["page-template page-template--admin", this.props.className].join(" ")}>
        {!hideHeader && <Header {...{ hideBackButton, backButtonLink, hideHamburger }} />}
        {this.props.children}
      </IonPage>
    );
  }
}

export default AdminTemplate;
